import { useTheme, useMediaQuery } from "@mui/material";
import IntegrationsDesktop from "./IntegrationsDesktop";
import IntegrationsMobile from "./IntegrationsMobile";

export default function Integrations() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return isMobile ? <IntegrationsMobile /> : <IntegrationsDesktop />;
}
